<template>
  <span>
    <div class="col-md-12">
      <div class="table-responsive">
        <table id="dataTableExample" class="table table-hover">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Spare Part</th>
              <th>QTY</th>
              <th>Comments</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <loading-table :isLoading="isLoading" cols="14"></loading-table>
            <tr v-if="form.rfq_details.length == 0">
              <td colspan="14" class="text-center">No data Found</td>
            </tr>
            <tr
              v-for="(rfq_detail, sr) in form.rfq_details"
              :key="`rfq_detail${sr}`"
            >
              <td>{{ sr + 1 }}.</td>
              <td>
                <my-select
                  disableFormControl="true"
                  :selection.sync="rfq_detail.spare_part_id"
                  :suggestions="spareParts"
                  placeholder="Select Spare Parts"
                ></my-select>
                <!-- :id="`rfq_detail${sr}`" -->
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="QTY"
                  v-model="rfq_detail.qty"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Comments"
                  v-model="rfq_detail.comments"
                />
              </td>
              <td>
                <div class="text-center">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteRfqDetail(rfq_detail)"
                    v-if="!rfq_detail.id"
                  >
                    Delete
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="delete_rfq_detail_data(rfq_detail.id)"
                    v-else
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="form.rfq_details">
              <td
                colspan="14"
                align="center"
                @click="addEmptyRfqDetails()"
                style="
                  background-color: #6571ff;
                  color: white;
                  border-radius: 10px;
                  box-shadow: none;
                "
              >
                Add New Row
              </td>
            </tr>
          </tbody>
        </table>
        <!-- /Table -->
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "RfqDetailFormWidget",
  props: ["form"],
  data() {
    return {
      spareParts: [
        { id: 1, name: "Spare 1" },
        { id: 2, name: "Spare 2" },
      ],
      isLoading: false,
    };
  },

  methods: {
    deleteRfqDetail(speed) {
      this.form.rfq_details = this.form.rfq_details.filter((ar) => ar != speed);
    },
    addEmptyRfqDetails() {
      this.form.rfq_details.push({
        company_id: this.company.id,
        spare_part_id: "",
        qty: "",
        comments: "",
      });
    },
    async delete_rfq_detail_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=rfq_details`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
